import React from 'react';
import clsx from 'clsx';

import './index.scss';

// import sho from 'assets/icon_shyokyuu.png';
// import chu from 'assets/icon_tyuukyuu.png';
// import jou from 'assets/icon_joukyuu.png';

const SpSkillLevel = ({
  value, id, onChange, checked, level, salary, skill,
}) => {
  const dir = require.context('assets/');
  const shoIcon = dir(`./icon_shyokyuu.png`);
  const chuIcon = dir(`./icon_tyuukyuu.png`);
  const jouIcon = dir(`./icon_joukyuu.png`);

  const DispImg = () => {
    switch (level) {
      case '初級': return (
        <span className="">
          <img className="rate" src={shoIcon} alt="" />
        </span>
      ); break;
      case '中級': return (
        <span className="">
          <img className="rate" src={chuIcon} alt="" />
        </span>
      ); break;
      case '上級': return (
        <span className="">
          <img className="rate" src={jouIcon} alt="" />
        </span>
      ); break;
      default: break;
    }
  };

  const DispSkill = () => {
    return (
      <span>
        {skill.map(data => (
          <span className="skill">
            {data}
            <br />
          </span>
        ))}
      </span>
    );
  };

  return (
    <div className={clsx('SpSkillLevel', { checked })}>
      <label htmlFor={id}>
        <div className='radio-input-wrapper'>
          <span className="">
            <span className="radioArea">
              <input
                type="radio"
                id={id}
                value={value}
                onChange={onChange}
                checked={checked}
              />
            </span>
            <span className="levelArea">
              <label className="level"> 
                {' '}
                {level}
                {' '}
              </label>
            </span>
            <span className="rateArea">
              <DispImg />
            </span>

            <div className="salaryArea">
              <div className="tagArea">
                <label className="tag">請求金額目安（1時間）</label>
              </div>
              <div className="salary">
                {salary}
              </div>
            </div>

            <div className="skillArea">
              <div className="tagArea">
                <label className="tag">OAスキル</label>
              </div>
              <div className="">
                <DispSkill />
              </div>
            </div>
          </span>
        </div>
      </label>
    </div>
  );
};

export default SpSkillLevel;